export default __webpack_public_path__ + "static/salesCrmbg-cd22d2c4c4f55386ee89f5a7cc35b715.png";